import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigator } from './Navigator';

export const Layout = (props) => {
  return (
    <>
        {/* <Navigator userRole={props.userRole}/> */}
        <Outlet />
    </>
  )
}
